import { useEffect, useState } from "react";
import "../../assets/style/DownloadReports.css";
import { FilterOptions } from "../../models/DashboardModels";
import { useDispatch, useSelector } from "react-redux";
import { grievanceDownloadReportsApi, lineOfBusinessMastersApi } from "../../api/grievancesApi";
import { toast } from "react-toastify";
import { DownloadReportsFilters } from "../../filters/DownloadReportsFilters";


const DownloadReports = () => {
  const [selectedFilter, setSelectedFilter] = useState<FilterOptions>();
  const dispatch: any = useDispatch()

  const {
    storeDownloadGrievanceData,
  } = useSelector((state: any) => state.grievances);

  const grievanceDownloadData = storeDownloadGrievanceData.response ?? []

   useEffect(() => {
      dispatch(lineOfBusinessMastersApi())
    }, [])

  const excelExport = () => {
    if (selectedFilter?.dateFrom && selectedFilter?.dateTo) {
      let sdate = selectedFilter.dateFrom
      let sepoch = sdate.getTime();
      let startdate = new Date(sepoch)

      let edate = selectedFilter.dateTo
      let eepoch = edate.getTime();
      let enddate = new Date(eepoch)

      const syear = startdate?.getFullYear();
      const smonth = (startdate.getMonth() + 1)?.toString()?.padStart(2, '0');
      const sday = (startdate?.getDate())?.toString()?.padStart(2, '0');
      const start = `${syear}-${smonth}-${sday}`;

      const eyear = enddate?.getFullYear();
      const emonth = (enddate.getMonth() + 1)?.toString()?.padStart(2, '0');
      const eday = (enddate?.getDate())?.toString()?.padStart(2, '0');
      const end = `${eyear}-${emonth}-${eday}`;

      dispatch(grievanceDownloadReportsApi(start, end, selectedFilter?.lob))
    }

    else {
      toast.warn('Please apply the required filters');
    }
  }

  return (
    <>
      <p className="page-header">Download Reports</p>
      <DownloadReportsFilters onApplyFilters={setSelectedFilter} />
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <button 
          className='create-grievance' 
          onClick={() => { excelExport() }}
        >
          Download Report
        </button>
      </div>
    </>
  );
};

export default DownloadReports;
